import { render, staticRenderFns } from "./CouriersTable.vue?vue&type=template&id=3cfb0aea&scoped=true&"
import script from "./CouriersTable.vue?vue&type=script&lang=js&"
export * from "./CouriersTable.vue?vue&type=script&lang=js&"
import style0 from "./CouriersTable.vue?vue&type=style&index=0&id=3cfb0aea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfb0aea",
  null
  
)

export default component.exports